import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  XCircleIcon,
} from "@heroicons/react/outline";
import { providerVerifiedLabel } from "../../utils/providerVerifiedLabel";

export const MiniStatusBadge = ({ status, id }) => {
  switch (status) {
    case "verified":
      return (
        <div
          className="bg-success-500 w-[1.75rem] p-[2px] rounded-[50%] hover:bg-success-600"
          id={id}
          data-tooltip-id="request-tooltip"
          data-tooltip-content={providerVerifiedLabel[status]}
        >
          <CheckCircleIcon stroke="white" />
        </div>
      );
    case "unverified":
      return (
        <div
          className="bg-danger-500 w-[1.75rem] p-[2px] rounded-[50%] hover:bg-danger-600"
          id={id}
          data-tooltip-id="request-tooltip"
          data-tooltip-content={providerVerifiedLabel[status]}
        >
          <XCircleIcon stroke="white" />
        </div>
      );
    default:
      return (
        <div
          className="bg-warning-500 w-[1.75rem] p-[2px] rounded-[50%] hover:bg-warning-600"
          id={id}
          data-tooltip-id="request-tooltip"
          data-tooltip-content={providerVerifiedLabel[status]}
        >
          <ExclamationCircleIcon stroke="white" />
        </div>
      );
  }
};
